<template>
  <div>
      <div >
        <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种管理-详情</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>
        <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
      <!-- 查询框 -->
      <span style="color:#006E4B;font-weight:900;font-size:20px">|   </span>
      <span style="font-size:20px;font-weight:700">其他险种详情</span>
      <div style="border:1px solid #DADADA;margin-top:10px"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm"> 
            <el-row>
                <el-col :span="12">
                <el-form-item label="保单名称" prop="name" style="margin-top:80px;width:80%">
                  {{$parent.ruleForm.insurance_name}}
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="投保账户" prop="name" style="margin-top:80px;width:80%">
                  {{$parent.ruleForm.insure_account}}
                </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :span="12">
                    <el-form-item label="投保内容" prop="region" >
                      {{$parent.ruleForm.dictionaries_id}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生效时间" required>
                      {{$parent.ruleForm.start_date}} ~ {{$parent.ruleForm.end_date}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="承保公司" prop="name" style="width:80%">
                  {{$parent.ruleForm.company_name}}
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="单价" prop="name" style="width:80%">
                  {{$parent.ruleForm.unit_price}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="保单号" prop="name" style="width:80%">
                  {{$parent.ruleForm.policy_no}}
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="保费" prop="name" style="width:80%">
                  {{$parent.ruleForm.premium}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="保额" prop="name" style="width:80%">
                  {{$parent.ruleForm.insured_amount}}
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="免赔额、比例" prop="name" style="width:80%">
                  {{$parent.ruleForm.proportion}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <!-- <el-col :span="12">
                <el-form-item label="适用范围" prop="region">
                    <el-col :span="4">    
                      {{$parent.ruleForm.company_id}}
                    </el-col>
                    <el-col :span="4">
                      {{$parent.ruleForm.plate_id}}
                    </el-col>
                    <el-col :span="4">
                      {{$parent.ruleForm.project_id}}
                    </el-col>
                    <el-col :span="4">
                      {{$parent.ruleForm.post_name}}
                    </el-col>
                    <el-col :span="4">
                      {{$parent.ruleForm.data}}
                    </el-col>
                </el-form-item>
                </el-col> -->

                <el-col :span="12">
                <el-form-item label="承保公司联系人" prop="name" style="width:80%">
                  {{$parent.ruleForm.company_contacts}}
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="备注" prop="name">
                  {{$parent.ruleForm.remarks}}
                </el-form-item>
                </el-col>

                <el-col :span="12">
                <el-form-item label="承保公司联系电话" prop="name" style="width:80%">
                  {{$parent.ruleForm.company_telephone}}
                </el-form-item>
                </el-col>
            </el-row>

            


            <el-row>
                <el-col :span="12">
                <el-form-item label="保单扫描件" prop="name" style="width:80%">
                  <img src="$parent.ruleForm.insurance_url">
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="附件" prop="name" style="width:80%">
                  {{$parent.ruleForm.enclosure_url}}
                </el-form-item>
                </el-col>
            </el-row>

        </el-form>

      </div>
      
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        ruleForm: {
          id:'',
          plate_id:'',
          post_id:'',
          age_id:'',
          project_id:'',
          dictionaries_id:'',
          insurance_name:'',
          insure_account:'',
          insured_amount:'',
          start_date:'',
          proportion:'',
          end_date:'',
          company_id:'',
          unit_price:'',
          policy_no:'',
          premium:'',
          company_contacts:'',
          company_telephone:'',
          remarks:'',
          spare1:'',
          spare2:'',
          insurance_url:'',
          enclosure_url:'',
        },
      };
      
    },
    methods: {
      Return(){
        this.$parent.Return();
      }
    },
    created() {
    this.ruleForm = this.$parent.ruleForm;
  },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Qtxzgl_edit.vue?35f0cc0a